import { useRef, useState } from "react";

export function useShareForecast() {
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [toast, setToast] = useState<string | null>(null);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const showToast = (msg: string) => {
    setToast(msg);
    setTimeout(() => setToast(null), 2000);
  };

  const shareForecast = async (shareText: string) => {
    // 1. Telegram WebApp API
    if (window?.Telegram?.WebApp?.share) {
      window.Telegram.WebApp.share({ text: shareText });
      return;
    }
    // 2. Clipboard API
    try {
      await navigator.clipboard.writeText(shareText);
      showToast("Текст прогноза скопирован!");
      return;
    } catch {
      // ignore
    }
    // 3. document.execCommand
    try {
      const textArea = document.createElement("textarea");
      textArea.value = shareText;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (successful) {
        showToast("Текст прогноза скопирован!");
        return;
      }
    } catch {
      // ignore
    }
    // 4. fallback: открыть модалку для ручного копирования
    setShowCopyModal(true);
  };

  const manualCopy = () => {
    if (!textAreaRef.current) return;
    textAreaRef.current.select();
    let copied = false;
    try {
      copied = document.execCommand("copy");
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Ошибка при копировании:", e);
    }
    setShowCopyModal(false);
    if (copied) {
      showToast("Текст прогноза скопирован!");
    } else {
      showToast("Не удалось скопировать. Выделите текст вручную.");
    }
  };

  return {
    showCopyModal,
    setShowCopyModal,
    toast,
    textAreaRef,
    shareForecast,
    manualCopy,
  };
}
